export const normalizeContentType = (contentType?: string | null): string =>
    (contentType || '').split(';')[0].trim().toLowerCase();

const pdfContentType = 'application/pdf';
const textOrSpreadsheetContentTypes = [
    'text/plain',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.ms-excel.sheet.macroEnabled.12'
].map(contentType => contentType.toLowerCase());

export const isPdfContentType = (contentType?: string | null): boolean =>
    normalizeContentType(contentType) === pdfContentType;

export const isTextOrSpreadsheetContentType = (contentType?: string | null): boolean =>
    textOrSpreadsheetContentTypes.includes(normalizeContentType(contentType));

export const isKnownNonImageContentType = (contentType?: string | null): boolean =>
    isPdfContentType(contentType) || isTextOrSpreadsheetContentType(contentType);
